import * as React from "react";
const SvgDot = props => <svg width="1em" height="1em" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><circle cx={1.5} cy={1.5} r={1.5} fill="#D81818" /></svg>;
export default SvgDot;